/* This is generated code, don't alter */
var IfcAlarmTypeEnum;
(function (IfcAlarmTypeEnum) {
    IfcAlarmTypeEnum[IfcAlarmTypeEnum["BELL"] = 0] = "BELL";
    IfcAlarmTypeEnum[IfcAlarmTypeEnum["BREAKGLASSBUTTON"] = 1] = "BREAKGLASSBUTTON";
    IfcAlarmTypeEnum[IfcAlarmTypeEnum["LIGHT"] = 2] = "LIGHT";
    IfcAlarmTypeEnum[IfcAlarmTypeEnum["MANUALPULLBOX"] = 3] = "MANUALPULLBOX";
    IfcAlarmTypeEnum[IfcAlarmTypeEnum["SIREN"] = 4] = "SIREN";
    IfcAlarmTypeEnum[IfcAlarmTypeEnum["WHISTLE"] = 5] = "WHISTLE";
    IfcAlarmTypeEnum[IfcAlarmTypeEnum["USERDEFINED"] = 6] = "USERDEFINED";
    IfcAlarmTypeEnum[IfcAlarmTypeEnum["NOTDEFINED"] = 7] = "NOTDEFINED";
})(IfcAlarmTypeEnum || (IfcAlarmTypeEnum = {}));
const IfcAlarmTypeEnumCount = 8;
export { IfcAlarmTypeEnum, IfcAlarmTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcAlarmTypeEnum = new Int32Array([6, -4, 21]);
let prefixSumAddressIfcAlarmTypeEnum = new Uint32Array([0, 12, 19, 28, 46, 53, 59, 74, 87]);
let slotMapIfcAlarmTypeEnum = new Int32Array([7, 4, 5, 1, 2, 0, 3, 6]);
let encodedDataIfcAlarmTypeEnum = (new TextEncoder()).encode(".NOTDEFINED..SIREN..WHISTLE..BREAKGLASSBUTTON..LIGHT..BELL..MANUALPULLBOX..USERDEFINED.");
let IfcAlarmTypeEnumSearch = new MinimalPerfectHash(gMapIfcAlarmTypeEnum, prefixSumAddressIfcAlarmTypeEnum, slotMapIfcAlarmTypeEnum, encodedDataIfcAlarmTypeEnum);
export { IfcAlarmTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcAlarmTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcAlarmTypeEnumSearch, input, cursor, endCursor);
}
